import CompaniesEditing from './CompaniesEditing';

export default CompaniesEditing;
